import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";
import { ProductComponent } from "./pages/product/product.component";
import { IndexComponent } from "./pages/index/index.component";
import { ProductListComponent } from "./pages/product-list/product-list.component";
import { CartComponent } from "./pages/cart/cart.component";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { ScanComponent } from './pages/scan/scan.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    children: [
      { path: "", redirectTo: "/inicio", pathMatch: "full" },
      { path: "inicio", component: IndexComponent },
      { path: "inicio/:id", component: IndexComponent },
      { path: "categoria/:id", component: ProductListComponent },
      { path: "producto/:id", component: ProductComponent },
      { path: "carrito", component: CartComponent },
      { path: "finalizar", component: CheckoutComponent },
      { path: "finalizar/:enviar", component: CheckoutComponent },
      { path: "scan/:id", component: ScanComponent },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
